import { PublicKey } from '@solana/web3.js';
import { GLOBAL_DUMP_VAULT_SEED, PROGRAM_ID } from '../programConstants';

const textEncoder = new TextEncoder();

export function getGlobalDumpVaultPda() {
  const [publicKey] = PublicKey.findProgramAddressSync(
    [textEncoder.encode(GLOBAL_DUMP_VAULT_SEED)],
    PROGRAM_ID
  );

  return publicKey;
}
